// src/pages/WarehousePage.js

import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import Footer from "common/Footer";
import WarehouseItemList from "common/Warehouse/WarehouseItemList";
import WarehouseItemUpload from "common/Warehouse/WarehouseItemUpload";
import WarehouseItemModal from "common/Warehouse/WarehouseItemModal";
import { Box, Fade, IconButton, Tooltip, Button } from "@mui/material";
import { Add as AddIcon, Refresh as RefreshIcon } from "@mui/icons-material";
import { useSnackbar } from "context/SnackbarContext";
import { useLanguage } from "context/LanguageContext";

const WarehousePage = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showSnackbar = useSnackbar();
  const { t } = useLanguage();

  const handleUploadSuccess = () => {
    setRefreshTrigger((prev) => !prev);
    showSnackbar(t("warehouseItemsUploadedSuccessfully"), "success");
  };

  const handleRefresh = () => {
    setIsRefreshing(true);
    setRefreshTrigger((prev) => !prev);
    setTimeout(() => {
      setIsRefreshing(false);
      showSnackbar(t("warehouseListRefreshed"), "success");
    }, 500);
  };

  const handleAddItemClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSuccess = () => {
    setRefreshTrigger((prev) => !prev);
    // Snackbar message is handled in the modal
  };

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {t("warehouseManagement")}
                </MDTypography>
                <Box display="flex" gap={1}>
                  <Tooltip title={t("addItem")}>
                    <Button
                      variant="contained"
                      color="white"
                      startIcon={<AddIcon />}
                      onClick={handleAddItemClick}
                    >
                      {t("addItem")}
                    </Button>
                  </Tooltip>
                  <Tooltip title={t("refreshList")}>
                    <IconButton
                      color="inherit"
                      onClick={handleRefresh}
                      sx={{
                        transform: isRefreshing ? "rotate(180deg)" : "none",
                        transition: "transform 0.5s ease-in-out",
                      }}
                    >
                      <RefreshIcon />
                    </IconButton>
                  </Tooltip>
                  <WarehouseItemUpload onUploadSuccess={handleUploadSuccess}>
                    <MDTypography variant="button" color="white">
                      {t("uploadItems")}
                    </MDTypography>
                  </WarehouseItemUpload>
                </Box>
              </MDBox>

              <Fade in={!isRefreshing} timeout={500}>
                <Box>
                  <WarehouseItemList refreshTrigger={refreshTrigger} />
                </Box>
              </Fade>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <WarehouseItemModal
        open={isModalOpen}
        handleClose={handleCloseModal}
        onSuccess={handleSuccess}
        item={null}
      />
      <Footer />
    </DashboardLayout>
  );
};

export default WarehousePage;
